import { redirect, type RouteObject } from 'react-router-dom';

import { type ItemType, itemTypes } from '@/models/item/item';

export const itemRoute: RouteObject = {
  path: 'items',
  children: [
    {
      path: '',
      loader: () => redirect('item'),
    },
    // season_pass is managed under its own /season-passes route, not as an item.
    ...itemTypes
      .filter((type) => type !== 'season_pass')
      .map(
        (type: ItemType): RouteObject => ({
          path: type,
          loader: () => ({ type }),
          lazy: () => import('./items'),
        }),
      ),
  ],
};
